<template>
	<div>
		<el-form ref="form" label-width="120px">
			<el-form ref="form" label-width="180px">
				<el-form-item required label="套餐名称：">
					<el-input v-model.trim="meal_name" type="text"></el-input>
				</el-form-item>
				<el-form-item  :label="item.lable" v-for="(item,index) in fromData" :key="index">
					<el-input v-model.trim="fromData[index].val" type="text"><template #append>
							{{item.append|| '次'}}
						</template></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="settingSubmit">保存</el-button>
				</el-form-item>
			</el-form>
		</el-form>
	</div>
</template>

<script>
	// import reg from '@/utils/reg.js'

	export default {

		props: ['id', 'type'],
		data() {
			return {
				meal_name: '',
				fromData: [{
						lable: '短信认证签约：',
						val: '',
						filed: 'esignsms_number'
					},
					{
						lable: '人脸识别认证签约：',
						val: '',
						filed: 'esignface_number'
					},
					{
						lable: '银行卡四要素认证签约：',
						val: '',
						filed: 'esignbank_number'
					},
					{
						lable: '智能算税：',
						val: '',
						filed: 'tax_number'
					},
					{
						lable: '短信通知类：',
						val: '',
						filed: 'sms_number',
						append: '条'
					},
					{
						lable: '自定义电子合同：',
						val: '',
						filed: 'cont_number',
						append: "份",
					},
					{
						lable: '管理员角色：',
						val: '',
						filed: 'adm_number'
					},
					{
						lable: '人才库人数：',
						val: '',
						filed: 'free_pool_number',
						append: "人（一年期限）",
					},
				]

			};
		},

		methods: {
			
			async settingSubmit() {
				if(!this.meal_name){
					return this.$message.warning('套餐名称不能为空')
				}
				let fromData={meal_name:this.meal_name}
				for (let item of this.fromData) {
					fromData[item.filed] = item.val
				}
				const res = await this.$api.postCreateSetMeal(fromData)
				if(res){
					this.$message.success('增加成功')
					this.$emit('success')
				}
			},
		},
		created() {

		},
		mounted() {

		},
	};
</script>

<style lang="scss" scoped>

</style>
